import { Switch } from '@headlessui/react';
import classNames from 'classnames';
import useWorldTheme from 'hooks/shared/useWorldTheme';
import type { FC } from 'react';
import { getTracingEvents } from 'utils/amplitude';
import type { toggleProps } from './Toggle.types';

const colorsMap = {
  bank: 'bg-bank',
  taxes: 'bg-taxes',
  expenses: 'bg-expenses',
  revenues: 'bg-revenues',
  primary: 'bg-primary-600',
};

const panelSizeMap = {
  xs: 'h-4 w-7',
  sm: 'h-5 w-9',
  base: 'h-6 w-11',
};

const ballSizeMap = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  base: 'h-5 w-5',
};

const ballTranslateMap = {
  xs: 'translate-x-3',
  sm: 'translate-x-4',
  base: 'translate-x-5',
};

const Toggle: FC<toggleProps> = ({
  label,
  enabled,
  onChange,
  disabled,
  tracing,
  id,
  color,
  size = 'base',
}) => {
  const tracingEvents = getTracingEvents(tracing, { onChange });
  const themeColor = useWorldTheme();

  return (
    <Switch
      id={id}
      checked={enabled}
      onChange={(v: any) => {
        if (disabled) return;
        tracingEvents.onChange(v);
      }}
      disabled={disabled}
      className={classNames(
        disabled ? 'opacity-60 cursor-not-allowed' : '',
        enabled ? colorsMap[color || themeColor || 'primary'] : 'bg-gray-200',
        'relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none',
        panelSizeMap[size],
      )}
    >
      {label && <span>{label}</span>}
      <span
        aria-hidden="true"
        className={classNames(
          enabled ? ballTranslateMap[size] : 'translate-x-0',
          'pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
          ballSizeMap[size],
        )}
      />
    </Switch>
  );
};

export default Toggle;
